export default {
    namespaced: true,
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObj({rootState}, tester_id) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}tester/${tester_id}`;
                this._vm.$axios.get(url, { headers: { 'Authorization': 'Bearer ' + rootState.token, 'Content-Type': 'application/json' } })
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            })
        },
        getObjs({rootState}) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + 'tester';
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        },
        getSummary({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `tester-data-summary?date=${payload.date}`;
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            });
        },
        getReportTesterDetail({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `tester-report-detail?date=${payload.date}&size=${payload.size}&coordinator=${payload.coordinator}`;
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            });
        },
        getDetails({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `tester/${payload.id}?date=${payload.date}&coordinator=${payload.coordinator}`;
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        },
        save({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "tester";
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        },
        update({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `tester/${payload.tester_id}/update`;
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        }
    }
}